import api from "./api";

/** Mirror of camera-meulance `GET /lives/schedule-limits`, resolved in the club's timezone. */
export type ScheduleLimits = {
  /** false para ADMIN/SUPPORT: nada fica desabilitado por antecedência mínima. */
  enforced: boolean;
  minLeadMinutes: number;
  maxAheadHours: number;
  timezone: string;
  /** Data/hora local (sem fuso) do primeiro início permitido, `YYYY-MM-DDTHH:mm`. */
  earliestStart: string;
  /** Data/hora local (sem fuso) do último início oferecido para um agendamento avulso. */
  latestStart: string;
};

export type DateTimeParts = { date: string; time: string };

/** `2026-10-27T16:15[:ss[.SSS]]` → `{ date: "2026-10-27", time: "16:15" }`. */
export const splitLocalDateTime = (value?: string | null): DateTimeParts | null => {
  const match = /^(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2})/.exec(value ?? "");
  return match ? { date: match[1], time: match[2] } : null;
};

export async function getScheduleLimits(deviceId?: number | null): Promise<ScheduleLimits | null> {
  try {
    const query = deviceId ? `?deviceId=${encodeURIComponent(deviceId)}` : "";
    const response = await api.get<{ data: ScheduleLimits }>(`/app/lives/schedule-limits${query}`);
    return response.data?.data ?? null;
  } catch (error) {
    console.warn("Failed to load schedule limits", error);
    // Os limites só melhoram a UX (o servidor continua validando); sem eles o seletor fica livre.
    return null;
  }
}
